<template>
    <v-content
        class="ma-0 pa-0"
    >
        <v-card
            outlined
            class="ma-0 pb-5"
        >
            <v-card-title
            class="headline"
            >
                Sign In
            </v-card-title>
            <v-row
                no-gutters
            >
                <v-text-field
                    v-model="username"
                    label="Email"
                    outlined
                    hide-details
                    class="px-5 mt-3 mb-0 py-0"
                    @keydown.enter="signIn"
                />
            </v-row>
            <v-row
                no-gutters
            >
                <v-text-field
                    v-model="password"
                    label="Password"
                    outlined
                    hide-details
                    class="px-5 mt-5 mb-0 py-0"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    @keydown.enter="signIn"
                />
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-left my-0 ml-5 pa-0 grey--text text--darken-2 caption"
                >
                    forgot password? <a @click.prevent="forgotPassword">click here</a>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                align="center"
                class="mt-3"
            >
                <v-col
                    class="ml-5 body-2"
                >
                    <a
                        @click.prevent="signUp"
                    >
                        Create Account
                    </a>
                </v-col>
                <v-col
                    class="text-right mr-5 mb-0 pa-0"
                >
                    <v-btn
                        v-if="!processingSubmit"
                        color="info"
                        @click.prevent="signIn"
                        :disabled="disableSubmit"
                    >
                        Submit
                    </v-btn>
                    <v-progress-circular
                        v-if="processingSubmit"
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-col>
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-right mt-1 pt-0 mx-5 red--text caption"
                >
                    {{errorMessage}} <a v-if="showConfirmUser" @click.prevent="resendVerification">Resend Link</a>
                </v-col>
            </v-row>
            <v-row
                v-if="resendCodeMessage != null"
                no-gutters
            >
                <v-col
                    class="text-right my-0 mx-5 pa-0 grey--text text--darken-4 caption"
                >
                    {{resendCodeMessage}}
                </v-col>
            </v-row>
        </v-card>
    </v-content>
</template>

<script>
    import { Auth } from 'aws-amplify'

    export default {
        data: () => ({
            showPassword: false,
            errorMessage: null,
            code: null,
            //email: null,
            password: null,
            resendCodeMessage: null,
            incorrectCodeMessage: null,
            processingSubmit: false,
            accountStatus: null,
        }),

        computed: {
            showConfirmUser() {
                return this.$store.getters['login/showConfirmUser'];
            },
            
            disableSubmit() {
                if(this.username == null | this.username == '' | this.password == null | this.password == '') {
                    return true
                } else {
                    return false
                }
            },

            accountInfo() {
                return this.$store.getters['data/account'];
            },

            username: {
                get() {
                    return this.$store.getters['login/username'];
                },
                set(value) {
                    this.$store.dispatch('login/updateUsername',value)
                }
            },

            menuStartDate() {
                let now = new Date();
                let date = (now .getMonth() + 1) + "/" + ((now .getDate()) + (7- now .getDay())) + "/" + (now .getFullYear());
                return date
            },

        },

        methods: {
            // async checkAccountStatus() {
            //     console.log('start async checkAccountStatus');
            //     this.$store.dispatch('data/loadAccount',this.username).then(
            //         response => {
            //             console.log('response:',response);
            //             this.accountStatus = response;
            //     });
            // },
            
            signIn() {
                this.processingSubmit = true;
                this.errorMessage = null;
                this.showPassword = false;
                this.resendCodeMessage = null;
                this.$store.dispatch('login/showConfirmUser',false);

                  
                Auth.signIn({
                    username: this.username,
                    password: this.password
                })
                .then(
                    user => {
                        //console.log('user:',user);
                        this.$store.dispatch('login/authDialog',false);
                        this.password = null;
                        this.processingSubmit = false;

                        this.$store.dispatch('data/updateUser',user);
                        this.$store.dispatch('login/signIn',user.attributes.email);
                        
                        if (user.attributes['custom:status'] == 'new') {
                            this.$store.dispatch('data/updateAccountStatus','verified');
                            this.$store.dispatch('data/generateMenu',this.menuStartDate);
                        }

                        if (user.attributes['custom:status'] == 'new' | user.attributes['custom:status'] == 'verified') {
                            this.$router.push('/signup');
                            this.$store.dispatch('data/updateStepper',6);
                        } else {
                            this.$router.push('/menu');
                        }
                    }
                ).catch(
                    error => {
                        console.log(error);
                        this.processingSubmit = false;
                        if(error.message == "User is not confirmed.") {
                            this.errorMessage = "Email not verified, please verify by clicking the link in your email";
                            this.$store.dispatch('login/showConfirmUser',true);
                        } else {
                            this.errorMessage = "Email or Password is incorrect";
                        }
                    }
                )
            },
            
            signUp() {
                //this.$store.dispatch('login/currentAuthView','SignUp');
                this.showPassword = false;
                this.$store.dispatch('login/updateUsername',null);
                this.$store.dispatch('login/authDialog',false);
                this.$router.push('/signup');
            },

            forgotPassword: function() {
                this.$store.dispatch('login/currentAuthView','ForgotPassword');
            },

            resendVerification: function() {
                this.resendCodeMessage = null;
                
                Auth.resendSignUp(this.username)
                .then(
                    data => {
                        console.log('code resent successfully');
                        this.resendCodeMessage = 'Code sent to ';
                        this.resendCodeMessage += data.CodeDeliveryDetails.Destination
                    }
                ).catch(
                    error => {
                        console.log(error);
                    }
                )
            },
        }
    }
</script>

<style scoped>
  a {
    color: blue !important;
    text-decoration: underline;
  }
</style>